import type { CatalogParamModel } from '@/shared/generated'

/** Controlled-input fallback when a param declares no `default`. */
const fallbackFor = (param: CatalogParamModel): unknown => {
	switch (param.type) {
		case 'boolean':
			return false
		case 'competitor_list':
			return []
		case 'string':
			return ''
		default:
			return undefined
	}
}

/**
 * Seed form values for a variant's params: the declared `default` when present,
 * otherwise a type-appropriate empty value so inputs stay controlled.
 */
export const paramsDefaults = (
	params: CatalogParamModel[]
): Record<string, unknown> =>
	Object.fromEntries(
		params.map((param) => [param.id, param.default ?? fallbackFor(param)])
	)
